// extracted by mini-css-extract-plugin
export default {"spinner":"BouncingDots_spinner__jp6MQ","sk-bouncedelay":"BouncingDots_sk-bouncedelay__5BqUK","bounce1":"BouncingDots_bounce1__P4v-i","bounce2":"BouncingDots_bounce2__tRVFQ"};